import GradientBorderRadius from "@/ui/gradient-border-radius";
import WalletScreenerHeader from "./wallet-screener-header";
import WalletDiscoveryFilterProvider from "@/providers/wallet-discovery-filter/wallet-discovery-filter-provider";
import WalletScreenerTable from "@pages/wallet-screener-table/wallet-screener-table.tsx";

const WalletScreenerPage = () => {
  return (
    <GradientBorderRadius
      background="section-gradient"
      overflow
      className="flex-1 flex w-full"
    >
      <div className="flex-1 flex flex-col w-full gap-[0.625rem] pt-[0.625rem]">
        <WalletDiscoveryFilterProvider>
          <WalletScreenerHeader />
          <WalletScreenerTable />
        </WalletDiscoveryFilterProvider>
      </div>
    </GradientBorderRadius>
  );
};

export default WalletScreenerPage;
